import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './LoginModern.css'; // Import the new CSS

const Login = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => { 
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('https://harmoni-chat-6.onrender.com/api/auth/login', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setUser(res.data.user);
      navigate('/chat');
    } catch (err) {
      alert('Invalid login credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-glass-card">
        
        {/* Left Side: Visuals */}
        <div className="auth-art-col">
          <div className="floating-ui-element">🪐</div>
          <h2>Welcome Back</h2>
          <p>Connect with your universe.</p>
        </div>

        {/* Right Side: Form */}
        <div className="auth-form-col">
          <div className="auth-header">
            <h1>Login</h1>
            <p>
              Don't have an account?{' '}
              <Link to="/register" className="auth-link">Register here</Link>
            </p>
          </div>

          <form onSubmit={handleSubmit} autoComplete="off">
            
            <div className="input-group">
              <input
                id="username"
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                required
                placeholder=" " /* Essential for floating label CSS */
              />
              <label htmlFor="username">Username</label>
            </div>

            <div className="input-group">
              <input
                id="password"
                type="password"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                required
                placeholder=" "
              />
              <label htmlFor="password">Password</label>
            </div>

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
            
          </form>
        </div>

      </div>
    </div>
  );
};

export default Login;